
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DZModelEvaluate from "@/views/评测管理/model/DZModelEvaluate";

@Component
export default class Evaluate extends Vue{

  @Prop() data;

  @Prop() sign;

  @Watch("data")
  watchData(value: any, oldValue: string){
    if(value){
      this.m_evaluate = value
    }
  }

  flag = true
  handle_edit(){
    this.flag = !this.flag
  }

  m_evaluate = new DZModelEvaluate();

  marks = ['极差', '差', '一般', '良', '优良']

  handle_submit(){
    this.$emit('ny_submit_evaluate', this.m_evaluate)
    this.handle_edit()
  }
}
